import { useTranslation } from 'react-i18next'

import { useModalStore } from '@features/modal'

import Button from '@shared/ui/button'

import styles from './styles.module.scss'

export default function SupportModal () {
  const { t: tc } = useTranslation('common')
  const { closeModal } = useModalStore()

  return (
    <div className={styles.modal}>
      <div className={styles.modal__text}>
        <a href="tel:+77132531002">+7 7132 531-002</a>
        <span>{tc('open.always')}</span>
      </div>
      <div className={styles.modal__text}>
        <a href="mailto:support@example.com">support@example.com</a>
        <span>{tc('open.always')}</span>
      </div>
      <Button onClick={() => closeModal('support')}>{tc('close')}</Button>
    </div>
  )
}
